import { render, staticRenderFns } from "./CopyFromFIDialog.vue?vue&type=template&id=a9816714&scoped=true"
import script from "./CopyFromFIDialog.vue?vue&type=script&lang=ts"
export * from "./CopyFromFIDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9816714",
  null
  
)

export default component.exports